(function () {
  function getScrollAmount(track) {
    var card = track.querySelector('.bestsellers__card');
    if (!card) return 316;
    var gap = parseFloat(getComputedStyle(track).gap) || 24;
    return card.getBoundingClientRect().width + gap;
  }

  function isPanelVisible(panel) {
    return panel && !panel.hidden;
  }

  function updateArrowState(track, carousel) {
    var panel = carousel.closest('.bestsellers__panel');
    if (!isPanelVisible(panel)) return;

    var nav = carousel.querySelector('.bestsellers__nav');
    if (!nav || nav.offsetParent === null) return;

    var prevBtn = nav.querySelector('[data-bestsellers-prev]');
    var nextBtn = nav.querySelector('[data-bestsellers-next]');
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var tolerance = 2;

    if (prevBtn) prevBtn.disabled = maxScroll <= tolerance || track.scrollLeft <= tolerance;
    if (nextBtn) nextBtn.disabled = maxScroll <= tolerance || track.scrollLeft >= maxScroll - tolerance;
  }

  function refreshCarousel(carousel) {
    var track = carousel.querySelector('[data-bestsellers-track]');
    if (!track) return;
    updateArrowState(track, carousel);
  }

  function bindCarousel(carousel) {
    if (carousel.dataset.bound) return;
    carousel.dataset.bound = 'true';

    var track = carousel.querySelector('[data-bestsellers-track]');
    var prevBtn = carousel.querySelector('[data-bestsellers-prev]');
    var nextBtn = carousel.querySelector('[data-bestsellers-next]');
    if (!track) return;

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(track), behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(track), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      updateArrowState(track, carousel);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function () {
        updateArrowState(track, carousel);
      });
      resizeObserver.observe(track);
    }

    track.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        updateArrowState(track, carousel);
      });
    });

    requestAnimationFrame(function () {
      refreshCarousel(carousel);
    });
  }

  function refreshSectionCarousels(section) {
    section.querySelectorAll('[data-bestsellers-carousel]').forEach(refreshCarousel);
  }

  function initBestsellers(section) {
    section.querySelectorAll('[data-bestsellers-carousel]').forEach(bindCarousel);

    var tabs = section.querySelectorAll('.bestsellers__tab');
    var panels = section.querySelectorAll('.bestsellers__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-tab-index');

        tabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-panel-index') === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;

          if (isActive) {
            var track = panel.querySelector('[data-bestsellers-track]');
            if (track) track.scrollLeft = 0;
          }
        });

        requestAnimationFrame(function () {
          refreshSectionCarousels(section);
        });
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        refreshSectionCarousels(section);
      }, 150);
    });

    requestAnimationFrame(function () {
      refreshSectionCarousels(section);
    });
  }

  function initAll() {
    document.querySelectorAll('.bestsellers').forEach(initBestsellers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bestsellers');
    if (section) initBestsellers(section);
  });
})();
